import React, { Dispatch, SetStateAction } from "react";
import { STATES_TYPE, UploadFile } from "../types/type";
import { handleBlur, handleChange } from "../utils/handleActions";
import { handleRequestOPT } from "../api";
import { useTranslation } from "react-i18next";

interface FormData { init_email: string; }
interface Errors { emailValid: boolean; }


interface FormAuthProps {
  email: string;
  errors: Errors;
  setErrors: Dispatch<SetStateAction<Errors>>;
  setFormData: Dispatch<SetStateAction<FormData>>;
  setStateUI: Dispatch<SetStateAction<STATES_TYPE>>;
  setLoadOnly: Dispatch<SetStateAction<boolean>>;
  uploadFiles: UploadFile[];
}

const FormAuthComponent: React.FC<FormAuthProps> = ({
  email,
  errors,
  setErrors,
  setFormData,
  setStateUI,
  setLoadOnly,
  uploadFiles,
}) => {

  const { t } = useTranslation();
  
  return (
    <form method="post">
      <div className={`lg:px-[10%] md:px-2 flex flex-col gap-4 mt-10`}>
        <label htmlFor="init_email">{t("key_label_email")}</label>
        
        <input id="init_email" placeholder={t("key_placeholder_email")} name="init_email"
          value={email}
          onChange={(e) => handleChange(e, setFormData)}
          onBlur={(e) => handleBlur(e, setErrors)}
          className={`outline-none p-4 text-xl text-gray-700 rounded-lg ${errors.emailValid ? "border border-red-500" : ""}`} />
        {errors.emailValid && <p className="text-red-500 text-sm">{t("key_error_email_invalid")}</p>}
      </div>

      <div className="lg:px-[10%] md:px-2 mt-10 relative flex flex-col gap-4">
        <button
          disabled={uploadFiles.length === 0 && !errors.emailValid && email !== ''}
          onClick={(e) => {
            e.preventDefault();
            if (uploadFiles.length > 0 && !errors.emailValid && email !== '') {
              handleRequestOPT(e, email, setStateUI, t);
            }
          }}
          className={`w-full flex justify-center outline-none items-center gap-4 rounded-lg p-4 font-bold text-sm transition 
           ${ (uploadFiles.length > 0 && !errors.emailValid && email !== '' ) ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
          {t("key_next")}
          {/* { true && <span className="animate-spin rounded-full h-4 w-4 border-b-4 border-white"/>} */}
        </button>
      </div>
    </form>
  );
};
export default FormAuthComponent;
